import React from 'react';

import { Box, ButtonGroup, Stack } from '@mui/material';

import PermissionedComponent from '~/components/Common/PermissionedComponent';

import BusinessDeactivateButton from '../../components/BusinessDeactivateButton';
import BusinessOrderSyncButton from '../../components/OrderSync/BusinessOrderSyncButton';

interface BusinessDetailsHeaderActionsProps {
  businessId: string;
}

export default function BusinessDetailsHeaderActions({ businessId }: BusinessDetailsHeaderActionsProps) {
  return (
    <Stack direction="column" spacing={2}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          gap: '16px',
          py: { xs: 1, md: 0 },
        }}
      >
        <ButtonGroup variant="outlined" size="small">
          <BusinessOrderSyncButton businessId={businessId} />
          <PermissionedComponent>
            <BusinessDeactivateButton businessId={businessId} />
          </PermissionedComponent>
        </ButtonGroup>
      </Box>
    </Stack>
  );
}
